import React, { useState, useEffect } from 'react'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { Company, CompanyAdminPrivilege, LifemarkUserModel } from 'web_common/tsx/api/db/Models'
import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import UserAccessAdminTable from 'components/user/list/UserAccessAdminTable'
import UserAccessUserTable from 'components/user/list/UserAccessUserTable'

interface UserListProps {

}

const UserList: React.FC<UserListProps> = (props) => {
    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [company, setCompany] = useState<Company|undefined>(undefined)
    const [companyUsers, setCompanyUsers] = useState<Array<LifemarkUserModel>|undefined>(undefined)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) => {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onCompany = (response: Company|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setCompany(response)
                }
            }

            db.company_detail(lifemarkUser.company, onCompany)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onUserList = (response: Array<LifemarkUserModel>|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    let userList = response.filter(
                        (obj, idx) =>
                    {
                        /*
                         * We don't want to show trucks
                         */
                        if(obj.truck !== null)
                        {
                            return false
                        }

                        if(obj.privilege === CompanyAdminPrivilege.NONE)
                        {
                            return false
                        }

                        if(obj.privilege === CompanyAdminPrivilege.ADMIN &&
                            lifemarkUser.privilege === CompanyAdminPrivilege.USER)
                        {
                            return false
                        }

                        if(obj.company_admin_superuser === true &&
                            lifemarkUser.company_admin_superuser === false)
                        {
                            return false
                        }

                        return true
                    })

                    setCompanyUsers(userList)
                }
            }

            db.list_users(lifemarkUser.company, undefined, onUserList)
        }
    }, [lifemarkUser])

    if(apiError === true)
    {
        return <ApiError/>
    }
    else if(lifemarkUser !== undefined)
    {
        if(lifemarkUser.privilege === CompanyAdminPrivilege.NONE)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(company !== undefined && companyUsers !== undefined)
        {
            if(lifemarkUser.privilege === CompanyAdminPrivilege.ADMIN)
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> User Access </h1>
                        <UserAccessAdminTable
                            userList={companyUsers}
                        />
                    </div>
                )
            }
            else
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> User Access </h1>
                        <UserAccessUserTable
                            userList={companyUsers}
                        />
                    </div>
                )
            }
        }
        else
        {
           return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> User Access </h1>
                    <Loading/>
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> User Access </h1>
                <Loading/>
            </div>
        )
    }
}

export default UserList
